import { SmsLifecyclePage } from "@/components/sms-lifecycle";
import { requirePermission } from "@/lib/casl/route-guards";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
  tab: z
    .enum(["cohorts", "settings", "observability"])
    .optional()
    .default("cohorts"),
  cohortId: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/sms-lifecycle/")({
  component: SmsLifecyclePage,
  validateSearch: searchSchema,
  beforeLoad: ({ context }) => {
    requirePermission(context.user, "read", "sms-lifecycle");
  },
});
